import { Component, Input } from '@angular/core';
import { HistoryModel, HistoryNoteModel, HistoryUpdateModel } from 'src/app/people/models/history';
import { ProfileHistoryProperty, propertyDescription } from '../../models/profileHistoryProperty';
import { AuditEntryState } from '../../models/auditEntryState';

@Component({
  selector: 'credential-history',
  templateUrl: './credential-history.component.html',
  styleUrls: ['./credential-history.component.scss'],
  standalone: false
})
export class CredentialHistoryComponent {
  @Input() histories: HistoryModel[];
  @Input() showScenarioName: boolean;
  propertyDescription: (state: string, prop: ProfileHistoryProperty) => string;

  constructor() {
    this.propertyDescription = propertyDescription;
  }

  isHistoryUpdate = (history: HistoryModel): HistoryUpdateModel => {
    const update = history as HistoryUpdateModel;
    if (update.properties?.length) {
      return update;
    }
    return null;
  };

  isHistoryNote = (history: HistoryModel): HistoryNoteModel =>
    this.isHistoryUpdate(history) ? null : (history as HistoryNoteModel);

  updateTitle = (history: HistoryUpdateModel) => {
    if (history.stateName == AuditEntryState.EntityAdded) {
      return `Evidence '${history.description}' Added`;
    }
    if (history.stateName == AuditEntryState.EntityModified) {
      return `Evidence '${history.description}' Updated`;
    }
    if (history.stateName == AuditEntryState.EntityDeleted) {
      return `Evidence '${history.description}' Removed`;
    }

    return history.stateName;
  };
}
